/**
 * used to transform bank details object.
 *
 * @param bank
 * @returns {{name: string, payuCode, priority: number, razorpayCode, status: boolean}}
 *
 * [ used primarily in ./bankListTransformer.js ]
 */

export const bankTransformer = (bank: any) => ({
  /* id: base-64 encoding. This ID isn't received from downstream/backend.
  *  It is created here.
  * */
  id: btoa(bank.name),
  name: bank.name || '',
  payuCode: bank.payuCode,
  priority: bank.priority || 0,
  razorpayCode: bank.razorpayCode,
  cashfreeCode: bank.cashfreeCode, // added for cashFree Seamless Flow
  // cashfreeCode: "3044" for SBI Bank
  status: bank.status || false,
  offerKeys: bank.offerKeys,
});
